import type { FastShopLowBalanceTrigger } from '@/queries/fast-shop/fast-shop.schema';

export const FAST_SHOP_STATE_CHANGE_EVENT = 'fast-shop:state-change';

export type FastShopFlowState = 'idle' | 'pending' | 'opening' | 'loading' | 'ready' | 'closed';

export type FastShopStateChange = {
  from: FastShopFlowState;
  to: FastShopFlowState;
  trigger: FastShopLowBalanceTrigger | null;
  reason: string;
};

export type FastShopFlowSnapshot = {
  state: FastShopFlowState;
  activeTrigger: FastShopLowBalanceTrigger | null;
  pendingTrigger: FastShopLowBalanceTrigger | null;
};

export const FAST_SHOP_INITIAL_FLOW: FastShopFlowSnapshot = {
  state: 'idle',
  activeTrigger: null,
  pendingTrigger: null,
};

export function canAcceptFastShopTrigger(state: FastShopFlowState) {
  return state === 'idle' || state === 'closed';
}

export function shouldPendFastShopTrigger(isFullscreen: boolean, isDocumentVisible: boolean) {
  return isFullscreen || !isDocumentVisible;
}
